import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'

import { useReports } from '../../hooks'


export default function IconRemoveReports({ idLineSelected, idRowSelected }) {

    const { showToaster } = useToaster()
    const { removeReports } = useReports()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove all selected reports?`, {
            onSuccess: () => {
                removeReports(idLineSelected, idRowSelected)
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" tooltipPosition="top-right" iconType="fontAwesome" title="Remove reports" onClick={handleClick} />
}